<div class="modal-content">
  <div class="modal-header">
    <h4>Vizsgatárgy kezdési időpontok eltolása</h4>
  </div>
  <div class="modal-body">
    <p>{{title}}</p>
    <p>Időpont változások:</p>
    <div id="table-container">
      <app-loader *ngIf="!shiftedDates"></app-loader>
      <table class="table table-striped" *ngIf="shiftedDates">
        <thead>
          <tr>
            <th>Vizsgatárgy</th>
            <th>Eredeti időpont</th>
            <th>Új időpont</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let date of shiftedDates">
            <td>{{ date.examSubject }}</td>
            <td>{{ date.originalDate?.setLocale('hu')?.toFormat('yyyy.MM.dd. HH:mm:ss') }}</td>
            <td [ngClass]="hasChange(date)?'bold':''">{{ date.shiftedDate?.setLocale('hu')?.toFormat('yyyy.MM.dd. HH:mm:ss') }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-dark me-auto" (click)="close()">Mégse</button>
    <button type="button" class="btn btn-primary text-white" (click)="shiftDates(false)">Nem</button>
    <button type="button" class="btn btn-success text-white" (click)="shiftDates(true)">Igen</button>
  </div>
</div>
